<script setup lang="ts">
  import { defineAsyncComponent, h, type Component } from "vue";
  import { pascalCase } from "change-case";

  defineProps<{
    fields: Array<{ name: string }>;
    card: Record<string, unknown>;
  }>();

  // A rejected suspensible import would leave the ReviewPane <Suspense> stuck on its fallback.
  const missingField = (name: string): Component => ({
    render: () => h("p", { class: "text-xs text-muted-foreground italic" }, `Preview unavailable for "${name}"`),
  });

  const components = new Map<string, Component>();
  const determineComponent = ({ name }: { name: string }): Component => {
    if (!components.has(name)) {
      components.set(
        name,
        defineAsyncComponent(() => import(`./Fields/${pascalCase(name)}Review.vue`).catch(() => missingField(name))),
      );
    }
    return components.get(name) as Component;
  };
</script>

<template>
  <div
    v-for="(field, index) in fields"
    :key="`review-card-body-field-${index}`">
    <div class="flex">
      <component
        :is="determineComponent(field)"
        :card="card" />
    </div>
  </div>
</template>
